import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginTop: Spacings.s48,
    },
    skeletonRoot: {
      height: 200,
    },
    skeletonFlex: {
      display: 'flex',
      height: '100%',
      justifyContent: 'space-between',
      gap: 30,
      marginTop: 20,
    },
    skeletonLinks: {
      extend: 'links',
      maxWidth: 200,
      maxHeight: 60,
      borderRadius: CornerRadius.r12,
    },
    skeletonTitle: {
      minHeight: 32,
      maxWidth: 400,
      margin: [Spacings.s24, 'auto'],
    },
    title: {
      marginBottom: Spacings.s48,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s30,
      textAlign: 'center',
      color: TextColors.base,

      '& > span': {
        fontWeight: FontWeights.bold,
        color: TextColors.base,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginBottom: Spacings.s24,
        fontSize: FontSizes.s24,
      },
    },
    description: {
      marginBottom: Spacings.s8,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l24,
      color: TextColors.base,
      textAlign: 'center',

      '& > span': {
        fontWeight: FontWeights.bold,
      },
    },
    links: {
      display: 'flex',
      justifyContent: 'space-between',

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        flexDirection: 'column',
        alignItems: 'center',
        flexWrap: 'wrap',
      },
    },
    link: {
      width: 160,
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.semibold,
      lineHeight: '40px',
      color: TextColors.base,
      transition: `background-color ${Timings.default} ${Easing.ease}`,
      borderRadius: CornerRadius.r20,
      textTransform: 'uppercase',
      textAlign: 'center',
      borderWidth: 2,
      borderStyle: 'solid',

      [canHover]: {
        '&:hover': {
          backgroundColor: BackgroundColors.tint3,
        },
      },
      [canTouch]: {
        '&:active': {
          backgroundColor: BackgroundColors.tint3,
        },
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '&:nth-child(2)': {
          margin: [Spacings.s32, 0],
        },
      },
    },
  }),
  {
    name: 'why-us',
  },
);

export default useStyles;
